module.exports = __webpack_public_path__ + "static/media/cars-questions.a9e1be77.csv";